import React, { useContext } from 'react';
import { NodeModel } from '@minoru/react-dnd-treeview';
import {
    EventsModel,
    InconsistenciesByEmployeeModel,
} from '../../../../models/inconsistencies-validation/inconsistenciesValidation';
import { Modal } from '../BaseModal';
import { AppContext } from '../../../context';
import { toast } from 'react-toastify';
import { TimeAttendanceEventsAPI } from '../../../../services/external/APIs/timeAttendanceEvents/TimeAttendanceEventsAPI';
import { getActionService } from '../../../../utils/getActionService';
import { ACTIONS } from '../../../../constants';

interface InconsistenciesDetailsProps {
    setModalOpen: (state: boolean) => void;
    inconsistencies: InconsistenciesByEmployeeModel[];
    isOpen: boolean;
    startDate: string;
    endDate: string;
    employee: NodeModel[] | undefined;
    treeEmployee: NodeModel[] | undefined;
}

export const InconsistenciesDetails = ({
    setModalOpen,
    isOpen,
    employee,
    startDate,
    endDate,
    inconsistencies,
    treeEmployee,
}: InconsistenciesDetailsProps) => {
    const {
        handlerOpenWorkshiftModal,
        handlerOpenAssociateMarkingModal,
        userInfo,
        langResources,
    } = useContext(AppContext);

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const renderNameAndDescription = (eventTypeId: number) => {
        switch (eventTypeId) {
            case 1:
                return langResources['inconsistencies.modal'][
                    'withoutWorkshift.label'
                ];

            case 2:
                return langResources['inconsistencies.modal'][
                    'withoutTimeAttendance.label'
                ];

            case 3:
                return langResources['inconsistencies.modal']['lateArrival.label'];

            case 4:
                return langResources['inconsistencies.modal']['earlyArrival.label'];

            case 5:
                return langResources['inconsistencies.modal'][
                    'incompleteTimeAttendance.label'
                ];

            case 6:
                return 'Marcaciones Fuera de Turno';
            
            case 7:
                return langResources['inconsistencies.modal']['earlyEvents.label'];

        }
    };

    const eventType = (eventTypeId: number) => {
        switch (eventTypeId) {
            case 1:
                return langResources['marking.modal']['entry'];

            case 2:
                return langResources['marking.modal']['exit'];

            case 3:
                return langResources['marking.modal']['invalid'];
        }
    };

    const convertDate = (date: string | null) => {
        if (date)
            return `Fecha: ${date.split('T')[0]}\n
        Hora: ${date.split('T')[1]}`;
        return 'No hay';
    };

    const handleChangeType = (model: EventsModel) => {
        const id = toast.loading('Cambiando tipo de eventos...');
        let eventTypeId =
            model.eventTypeId == 1 ? 2 : model.eventTypeId == 2 ? 1 : 3;

        TimeAttendanceEventsAPI.changeEventType({
            eventId: model.eventId,
            eventTypeId: eventTypeId,
        })
            .then((res) => {
                toast.update(id, {
                    render: 'Se cambió el tipo del evento correctamente, vuelve a consultar las inconsistencias',
                    type: 'success',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
                handleCloseModal();
            })
            .catch((err) => {
                toast.update(id, {
                    render: err.response.data,
                    type: 'error',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
            });
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle={
                langResources['inconsistencies.modal'][
                    'details.inconsistencies.title'
                ] +
                ' de ' +
                employee?.at(0)?.text
            }
            onClose={handleCloseModal}
            zindex={90000}
            widthCustom='850px'
            onSubmit={handleCloseModal}
        >
            <div className='modal-body text-black  justify-content-center rounded row m-1'>
                <div className=''>
                    {inconsistencies.map((inc) => (
                        <div className=''>
                            {inc.inconsistencies.map((type, i) => (
                                <div className='' key={i}>
                                    <div
                                        className={
                                            [5, 2, 1].includes(
                                                type.inconsistencyTypes
                                            )
                                                ? 'd-flex  justify-content-between'
                                                : ''
                                        }
                                    >
                                        <h4 className='mb-0'>
                                            <span className='badge rounded-pill bg-warning'>
                                                {renderNameAndDescription(
                                                    type.inconsistencyTypes
                                                )}
                                            </span>
                                        </h4>

                                        {[6, 1].includes(
                                            type.inconsistencyTypes
                                        ) && (
                                            <button
                                                className='btn btn-sm btn-outline-primary d-flex align-items-center'
                                                onClick={() => {
                                                    localStorage.setItem(
                                                        'isValidatingInconsistencies',
                                                        'true'
                                                    );
                                                    handlerOpenWorkshiftModal(
                                                        startDate,
                                                        endDate,
                                                        [
                                                            //@ts-ignore
                                                            employee?.at(0),
                                                        ],
                                                        false
                                                    );
                                                }}
                                            >
                                                <i className=' ri-add-line'></i>
                                                {
                                                    langResources[
                                                        'inconsistencies.modal'
                                                    ][
                                                        'details.inconsistencies.add.workshift'
                                                    ]
                                                }
                                            </button>
                                        )}
                                    </div>

                                    {type.inconsistencyTypes.valueOf() == 6 ? (
                                        <div>
                                            <ul className=' mt-0 pt-0 list-group text-black list-group-flush'>
                                                {(type.firstArrivalDate ||
                                                    type.firstArrivalTime) && (
                                                    <li className='d-flex justify-content-between text-black list-group-item'>
                                                        <div className='d-flex flex-column'>
                                                            <p className='mb-0 fw-bold'>
                                                                Hora Entrada:
                                                            </p>
                                                            <p className='text-muted'>
                                                                {convertDate(
                                                                    type.firstArrivalDate
                                                                )}
                                                            </p>
                                                        </div>
                                                        <div className='d-flex flex-column text-end'>
                                                            <p className='mb-0 fw-bold'>
                                                                Entrada:
                                                            </p>
                                                            <div
                                                                className={
                                                                    'd-flex gap-2'
                                                                }
                                                            >
                                                                <p className='text-muted'>
                                                                    {convertDate(
                                                                        type.firstArrivalTime
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}

                                                {(type.secondDepartureDate ||
                                                    type.secondDepartureTime) && (
                                                    <li className='d-flex justify-content-between  list-group-item'>
                                                        <div className='d-flex flex-column'>
                                                            <p className='mb-0 fw-bold'>
                                                                Hora Salida:
                                                            </p>
                                                            <p className='text-muted'>
                                                                {convertDate(
                                                                    type.secondDepartureDate
                                                                )}
                                                            </p>
                                                        </div>
                                                        <div className='d-flex flex-column text-end'>
                                                            <p className='mb-0 fw-bold'>
                                                                Salida:
                                                            </p>
                                                            <div
                                                                className={
                                                                    'd-flex gap-2'
                                                                }
                                                            >
                                                                <p className='text-muted'>
                                                                    {convertDate(
                                                                        type.secondDepartureTime
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>
                                            <hr />

                                            <div className='p-3 pt-1 pb-0'>
                                                <p className='fw-bold'>
                                                    Marcaciones fuera del turno
                                                </p>
                                                {type.outOfWorkshiftEvents.map(
                                                    (owse, i) => (
                                                        <div
                                                            key={i}
                                                            className='mb-2 mx-2'
                                                        >
                                                            <p>
                                                                Ubicación{' '}
                                                                {
                                                                    owse.ubicationDescription
                                                                }{' '}
                                                                | Tipo{' '}
                                                                {eventType(
                                                                    owse.eventTypeId
                                                                )}{' '}
                                                                | Fecha{' '}
                                                                {
                                                                    owse.eventDate.split(
                                                                        'T'
                                                                    )[0]
                                                                }{' '}
                                                                | Hora{' '}
                                                                {owse.eventTime}
                                                            </p>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <ul className=' mt-0 pt-0 list-group text-black list-group-flush'>
                                            {(type.firstArrivalDate ||
                                                type.firstArrivalTime) && (
                                                <li className='d-flex justify-content-between text-black  list-group-item'>
                                                    <div className='d-flex flex-column'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.workshift.entry'
                                                                ]
                                                            }
                                                            :
                                                        </p>
                                                        <p className='text-muted'>
                                                            {convertDate(
                                                                type.firstArrivalDate
                                                            )}
                                                        </p>
                                                    </div>

                                                    <div className='d-flex flex-column text-end'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.entry.time'
                                                                ]
                                                            }
                                                            :
                                                        </p>
                                                        <div
                                                            className={
                                                                [5, 2, 1].includes(
                                                                    type.inconsistencyTypes
                                                                )
                                                                    ? 'd-flex gap-2'
                                                                    : ''
                                                            }
                                                        >
                                                            <p className='text-muted mb-0'>
                                                                {convertDate(
                                                                    type.firstArrivalTime
                                                                )}
                                                            </p>

                                                            {[5, 2].includes(
                                                                type.inconsistencyTypes
                                                            ) &&
                                                                !type.firstArrivalTime && (
                                                                    <button
                                                                        className='btn btn-sm btn-outline-primary d-flex align-items-center p-1'
                                                                        onClick={() => {
                                                                            localStorage.setItem(
                                                                                'time',
                                                                                JSON.stringify(
                                                                                    {
                                                                                        type: 'entry',
                                                                                        hour: type.firstArrivalDate?.split(
                                                                                            'T'
                                                                                        )[1],
                                                                                    }
                                                                                )
                                                                            );
                                                                            handlerOpenAssociateMarkingModal(
                                                                                startDate,
                                                                                endDate,
                                                                                [
                                                                                    //@ts-ignore
                                                                                    employee?.at(
                                                                                        0
                                                                                    ),
                                                                                ],
                                                                                undefined
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className=' ri-add-line'></i>
                                                                        {
                                                                            langResources[
                                                                                'inconsistencies.modal'
                                                                            ][
                                                                                'details.inconsistencies.add.time.attendance'
                                                                            ]
                                                                        }
                                                                        :
                                                                    </button>
                                                                )}
                                                        </div>
                                                    </div>
                                                </li>
                                            )}

                                            {(type.firstDepartureDate ||
                                                type.firstDepartureTime) && (
                                                <li className='d-flex justify-content-between text-black list-group-item'>
                                                    <div className='d-flex flex-column'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.workshift.exit'
                                                                ]
                                                            }
                                                        </p>
                                                        <p className='text-muted'>
                                                            {convertDate(
                                                                type.firstDepartureDate
                                                            )}
                                                        </p>
                                                    </div>

                                                    <div className='d-flex flex-column text-end'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.exit.time'
                                                                ]
                                                            }
                                                        </p>
                                                        <div
                                                            className={
                                                                [5, 2, 1].includes(
                                                                    type.inconsistencyTypes
                                                                )
                                                                    ? 'd-flex gap-2'
                                                                    : ''
                                                            }
                                                        >
                                                            <p className='text-muted mb-0'>
                                                                {convertDate(
                                                                    type.firstDepartureTime
                                                                )}
                                                            </p>

                                                            {[5, 2].includes(
                                                                type.inconsistencyTypes
                                                            ) &&
                                                                !type.firstDepartureTime && (
                                                                    <button
                                                                        className='btn btn-sm btn-outline-primary d-flex align-items-center p-1'
                                                                        onClick={() => {
                                                                            localStorage.setItem(
                                                                                'time',
                                                                                JSON.stringify(
                                                                                    {
                                                                                        type: 'exit',
                                                                                        hour: type.firstDepartureDate?.split(
                                                                                            'T'
                                                                                        )[1],
                                                                                    }
                                                                                )
                                                                            );
                                                                            handlerOpenAssociateMarkingModal(
                                                                                startDate,
                                                                                endDate,
                                                                                [
                                                                                    //@ts-ignore
                                                                                    employee?.at(
                                                                                        0
                                                                                    ),
                                                                                ],
                                                                                undefined
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className=' ri-add-line'></i>
                                                                        {
                                                                            langResources[
                                                                                'inconsistencies.modal'
                                                                            ][
                                                                                'details.inconsistencies.add.time.attendance'
                                                                            ]
                                                                        }
                                                                        :
                                                                    </button>
                                                                )}
                                                        </div>
                                                    </div>
                                                </li>
                                            )}

                                            {(type.secondArrivalDate ||
                                                type.secondArrivalTime) && (
                                                <li className='d-flex justify-content-between text-black list-group-item'>
                                                    <div className='d-flex flex-column'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.workshift.entry2'
                                                                ]
                                                            }
                                                            :
                                                        </p>
                                                        <p className='text-muted'>
                                                            {convertDate(
                                                                type.secondArrivalDate
                                                            )}
                                                        </p>
                                                    </div>

                                                    <div className='d-flex flex-column text-end'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.entry.time2'
                                                                ]
                                                            }
                                                            :
                                                        </p>
                                                        <div
                                                            className={
                                                                [5, 2, 1].includes(
                                                                    type.inconsistencyTypes
                                                                )
                                                                    ? 'd-flex gap-2'
                                                                    : ''
                                                            }
                                                        >
                                                            <p className='text-muted mb-0'>
                                                                {convertDate(
                                                                    type.secondArrivalTime
                                                                )}
                                                            </p>

                                                            {[5, 2].includes(
                                                                type.inconsistencyTypes
                                                            ) &&
                                                                !type.secondArrivalTime && (
                                                                    <button
                                                                        className='btn btn-sm btn-outline-primary d-flex align-items-center p-1'
                                                                        onClick={() => {
                                                                            localStorage.setItem(
                                                                                'time',
                                                                                JSON.stringify(
                                                                                    {
                                                                                        type: 'entry',
                                                                                        hour: type.secondArrivalDate?.split(
                                                                                            'T'
                                                                                        )[1],
                                                                                    }
                                                                                )
                                                                            );
                                                                            handlerOpenAssociateMarkingModal(
                                                                                startDate,
                                                                                endDate,
                                                                                [
                                                                                    //@ts-ignore
                                                                                    employee?.at(
                                                                                        0
                                                                                    ),
                                                                                ],
                                                                                undefined
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className=' ri-add-line'></i>
                                                                        {
                                                                            langResources[
                                                                                'inconsistencies.modal'
                                                                            ][
                                                                                'details.inconsistencies.add.time.attendance'
                                                                            ]
                                                                        }
                                                                        :
                                                                    </button>
                                                                )}
                                                        </div>
                                                    </div>
                                                </li>
                                            )}

                                            {(type.secondDepartureDate ||
                                                type.secondDepartureTime) && (
                                                <li className='d-flex justify-content-between text-black list-group-item'>
                                                    <div className='d-flex justify-content-center flex-column'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.workshift.exit2'
                                                                ]
                                                            }
                                                            :
                                                        </p>
                                                        <p className='text-muted'>
                                                            {convertDate(
                                                                type.secondDepartureDate
                                                            )}
                                                        </p>
                                                    </div>

                                                    <div className='d-flex justify-content-center flex-column text-end'>
                                                        <p className='mb-0 fw-bold'>
                                                            {
                                                                langResources[
                                                                    'inconsistencies.modal'
                                                                ][
                                                                    'details.inconsistencies.exit.time2'
                                                                ]
                                                            }
                                                            :
                                                        </p>
                                                        <div
                                                            className={
                                                                [5, 2, 1].includes(
                                                                    type.inconsistencyTypes
                                                                )
                                                                    ? 'd-flex gap-2 '
                                                                    : ''
                                                            }
                                                        >
                                                            <p className='text-muted  mb-0'>
                                                                {convertDate(
                                                                    type.secondDepartureTime
                                                                )}
                                                            </p>

                                                            {[5, 2].includes(
                                                                type.inconsistencyTypes
                                                            ) &&
                                                                !type.secondDepartureTime && (
                                                                    <button
                                                                        className='btn btn-sm btn-outline-primary d-flex align-items-center p-1'
                                                                        onClick={() => {
                                                                            localStorage.setItem(
                                                                                'time',
                                                                                JSON.stringify(
                                                                                    {
                                                                                        type: 'exit',
                                                                                        hour: type.secondDepartureDate?.split(
                                                                                            'T'
                                                                                        )[1],
                                                                                    }
                                                                                )
                                                                            );
                                                                            handlerOpenAssociateMarkingModal(
                                                                                startDate,
                                                                                endDate,
                                                                                [
                                                                                    //@ts-ignore
                                                                                    employee?.at(
                                                                                        0
                                                                                    ),
                                                                                ],
                                                                                undefined
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className=' ri-add-line'></i>
                                                                        {
                                                                            langResources[
                                                                                'inconsistencies.modal'
                                                                            ][
                                                                                'details.inconsistencies.add.time.attendance'
                                                                            ]
                                                                        }
                                                                    </button>
                                                                )}
                                                        </div>
                                                    </div>
                                                </li>
                                            )}
                                        </ul>
                                    )}

                                    {type.events && (
                                        <div className='mt-4'>                                      
                                            <div className='card border-0 shadow-sm'>
                                                <div className='table-responsive'>
                                                    <table className='table table-hover mb-0'>
                                                        <thead>
                                                            <tr className='border-bottom'>
                                                                <th className='text-muted fw-semibold small py-3 ps-4 border-0'>
                                                                    <i className='ri-map-pin-line me-1'></i>
                                                                    {langResources['marking.modal']['ubication']}
                                                                </th>
                                                                <th className='text-muted fw-semibold small py-3 border-0'>
                                                                    <i className='ri-calendar-line me-1'></i>
                                                                    {langResources['marking.modal']['date']}
                                                                </th>
                                                                <th className='text-muted fw-semibold small py-3 border-0'>
                                                                    <i className='ri-time-line me-1'></i>
                                                                    {langResources['marking.modal']['dateHour']}
                                                                </th>
                                                                <th className='text-muted fw-semibold small py-3 border-0'>
                                                                    <i className='ri-price-tag-3-line me-1'></i>
                                                                    {langResources['marking.modal']['type']}
                                                                </th>
                                                                <th className='text-muted fw-semibold small py-3 text-center border-0'>
                                                                    <i className='ri-settings-3-line me-1'></i>
                                                                    {langResources['marking.modal']['actions']}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {type.events.map((m, index) => (
                                                                <tr
                                                                    key={m.eventId}
                                                                    className='border-bottom border-light'
                                                                    style={{
                                                                        transition: 'all 0.2s ease',
                                                                        backgroundColor: index % 2 === 0 ? 'transparent' : 'rgba(0,0,0,0.02)'
                                                                    }}
                                                                >
                                                                    <td className='py-3 ps-4 align-middle'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <span className='text-dark fw-normal'>
                                                                                {m.ubicationDescription}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td className='py-3 align-middle'>
                                                                        <span className='text-muted'>
                                                                            {m.eventDate.split('T')[0]}
                                                                        </span>
                                                                    </td>
                                                                    <td className='py-3 align-middle'>
                                                                        <span className='badge bg-light text-dark px-3 py-2 fw-semibold'>
                                                                            {m.eventTime}
                                                                        </span>
                                                                    </td>
                                                                    <td className='py-3 align-middle'>
                                                                        <span
                                                                            className={`badge px-3 py-2 d-flex align-items-center gap-2 
                                                                                 ${m.eventTypeId === 1 ? 'event-entry' : m.eventTypeId === 2 ? 'event-exit' : 'event-invalid'}`}
                                                                        >
                                                                            {m.eventTypeId === 1 && <i className="ri-login-box-line event-entry"></i>}
                                                                            {m.eventTypeId === 2 && <i className="ri-logout-box-line event-exit"></i>}
                                                                            {m.eventTypeId === 3 && <i className="ri-error-warning-line event-invalid"></i>}
                                                                            {eventType(m.eventTypeId)}
                                                                        </span>
                                                                    </td>
                                                                    <td className='py-3 text-center align-middle'>
                                                                        {getActionService(
                                                                            userInfo.actions,
                                                                            ACTIONS['change.event.types']
                                                                        ) &&
                                                                            (m.eventTypeId === 1 || m.eventTypeId === 2) ? (
                                                                            <button
                                                                                className='btn btn-sm btn-outline-primary px-3 py-2 d-inline-flex align-items-center gap-2 fw-semibold'
                                                                                onClick={() => handleChangeType(m)}
                                                                                title='Cambiar tipo de evento'
                                                                            >
                                                                                <i className='ri-swap-line fs-6'></i>
                                                                                <span className='d-none d-md-inline'>Cambiar</span>
                                                                            </button>
                                                                        ) : (
                                                                            <span className='text-muted small'>—</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {inc.inconsistencies.length > 1 && <hr />}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};
